import React, { memo } from "react";

import {
  OptionList,
  OptionRow,
  OptionText,
  OptionKind,
  OptionTitle,
  OptionDescription,
  OptionActions,
} from "./styles";

import { Button, SecondaryButton } from "basics/buttons";
import DownloadIcon from "icons/DownloadIcon";

/**
 * Fila de un paso de selección. La usan tanto las temáticas como los premios:
 * cambia el rótulo (`kind`) y si trae o no instructivo.
 */
function InternalEntryOption({ kind, title, description, fileUrl, onSelect }) {
  return (
    <OptionRow>
      <OptionText>
        <OptionKind>{kind}</OptionKind>
        <OptionTitle>{title}</OptionTitle>
        {description && <OptionDescription>{description}</OptionDescription>}
      </OptionText>

      <OptionActions>
        {fileUrl && (
          <SecondaryButton
            as="a"
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon width="1.7rem" height="1.7rem" />
            Instructivo
          </SecondaryButton>
        )}

        <Button type="button" disabled={!onSelect} onClick={onSelect}>
          Seleccionar
        </Button>
      </OptionActions>
    </OptionRow>
  );
}

export const EntryOption = memo(InternalEntryOption);

export { OptionList, OptionFooter } from "./styles";
